import reduceReducers from 'reduce-reducers'
import { combineReducers } from 'redux'

import { contentEngineReducer } from 'react-content-engine'
import { createForms } from 'react-redux-form'
import { adminReducer } from '../data/models/admin'
import { initAroundTheWorld } from '../data/models/aroundTheWorld/entry'
import { initialBookingConfirmation } from '../data/models/bookingConfirmation'
import { entryPointReducer } from '../data/models/entry_point'
import experimentsReducer from '../data/models/experiments'
import { followerReducer } from '../data/models/follower'
import { initialFollowForm } from '../data/models/followForm'
import {
  default as funnelOrderReducerOld,
  initialOrder,
} from '../data/models/funnelOrder'
import initialGiftcardOrder from '../data/models/giftcardOrder'
import { localeReducer } from '../data/models/locale'
import { memberReducer } from '../data/models/member'
import { memberGetMemberReducer } from '../data/models/member_get_member'
import { modifiedReducer } from '../data/models/modified'
import { pageReducer } from '../data/models/page'
import { paymentSlugReducer } from '../data/models/payment_slug'
import { initialPayment } from '../data/models/paymentOrder'
import { initialTopupOrder } from '../data/models/topupOrder'
import unlockTokenReducer from '../data/models/unlock_token'
import unlockPageReducer from '../data/models/unlockPage'
import { AppState } from '../data/state'
import { initialUI } from '../data/ui'
import { funnelOrderReducer } from './funnelOrder/reducer'

export const rootReducer = combineReducers<AppState>({
  locale: localeReducer,
  member: memberReducer,
  admin: adminReducer,
  contentEngine: contentEngineReducer,
  unlockPage: unlockPageReducer,
  follower: followerReducer,
  memberGetMember: memberGetMemberReducer,
  page: pageReducer,
  unlockToken: unlockTokenReducer,
  entryPoint: entryPointReducer,
  paymentSlug: paymentSlugReducer,
  experiments: experimentsReducer,
  modified: modifiedReducer,
  ...createForms({
    funnelOrder: reduceReducers(
      initialOrder,
      funnelOrderReducer,
      funnelOrderReducerOld,
    ),
    giftcardOrder: initialGiftcardOrder,
    topupOrder: initialTopupOrder,
    paymentOrder: initialPayment,
    ui: initialUI,
    followForm: initialFollowForm,
    bookingConfirmation: initialBookingConfirmation,
    aroundTheWorld: initAroundTheWorld,
  }),
})
